<section class="buy-wifi-shopping-cart">
    <article class="wrapper">
        <div class="row-wrapper">
            <div class="col large-6 medium-6 small-6 mobile-hidden">
                <div class="col large-4 medium-4 small-12" id="buy-wifi-keys">
                    <h4>{{'wifiKeys' | translate }}</h4>
                    <div class="keys-selected pad-l-10">
                        <p>
                            <span class="icon-wifi-grey-small"></span>x {{sessionValue}}
                        </p>
                    </div>
                </div>
                <div class="col large-6 medium-6 small-12 buy-wifi-destination pad-t-10" *ngIf="!showEBforPointsBuy">
                    <h4>{{'validForTrip' | translate }}</h4>
                    <p>{{currentSegment.departureAirport.code}} - {{currentSegment.arrivalAirport.code}}
                    <p>{{currentSegment.marketingCarrierCode}}{{currentSegment.flightNumber}}</p>
                </div>
                <div class="col large-6 medium-6 small-12 buy-wifi-destination pad-t-10" *ngIf="showEBforPointsBuy">
                    <h4>{{'validForTrip' | translate }}</h4>
                    <p>{{origin.iataCode}} - {{destination.iataCode}}
                    <p>{{flightNumber}}</p>
                </div>
            </div>
            <div class="col large-6 medium-6 small-12">
                <div class="col large-4 medium-4 small-6 buy-wifi-total" tabindex="0">
                    <h4 class="small-6 title" tabindex="-1" aria-hidden="true">{{'total' | translate }}</h4>
                    <div class="cart-total relative pad-l-10" tabindex="-1" aria-hidden="true"
                        *ngIf="!showEBforPointsBuy">
                        <span class="total-price">{{sessionValue*price | formatPrice:true:true:'no'}} </span>
                    </div>
                    <div class="cart-total relative pad-l-10" tabindex="-1" aria-hidden="true"
                        *ngIf="showEBforPointsBuy">
                        <span class="total-price">{{sessionValue*price}} {{'pointsText' | translate }}</span>
                    </div>
                </div>
                <div class="col large-3 medium-3 small-12 mobile-hidden" id="buy-wifi-taxes-fee"
                    *ngIf="!showEBforPointsBuy">
                    <p class="taxes-details pad-t-15 pad-r-8">
                        <span>{{'cart.taxIncluded' | translate }}</span>
                    </p>
                </div>
                <div class="col large-5 medium-5 small-6" id="buy-wifi-continue">
                    <div class="button-wrap">
                        <!-- <button class="btn primary large buy-wifi-continue-button" id="buy-wifi-continue-button" (click)="proceedToPayment($event)">{{'switch.continue' | translate }}</button> -->
                        <button class="btn primary large buy-wifi-continue-button" id="buy-wifi-continue-button"
                            (click)="showMapConfirm()">CONTINUE</button>

                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </article>
</section>
<div class="clear"></div>
<section class="modal wifi-onboard-email-overlay pt-25" *ngIf="mapOverlay" style="display: block">
    <div class="modal-dialog popup-max-width">
        <div class="modal-tnc-content popup-padding">

            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <div *ngIf="!showLongRangeMap">
                            <img src="/onboard/assets/images/ShortRangeMap.jpg">
                        
                        </div>
                        <div *ngIf="showLongRangeMap">
                            <img src="/onboard/assets/images/LongRangeMap.jpg">
                        </div>
                      
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <p class="mb-10">I hereby confirm that I have reviewed the coverage map and understand that I might experience periods of outage during my WiFi session.</p>
                    </div>
                </div>

                <div class="row text-center">
                    <div class="col-md-12">
                        <button class="btn primary medium buy-wifi-continue-button mr-10" id="buy-wifi-continue-button"
                            (click)="proceedToPayment($event)">AGREE</button>
                        <button class="btn primary medium" tabindex="0" (click)="urlRedirectToHomepage()">DENY</button>

                    </div>
                </div>


                <!--<p [innerHtml]="'ebCampaign.instruction' | translate" id="ebCampInst"></p>-->

            </div>



        </div>
    </div>
</section>
<div class="clear"></div>
<!-- Buy Wifi Email Update Overlay -->
<section class="modal wifi-onboard-email-overlay" id="wifi-onboard-email-overlay" *ngIf="updateEmailOverLay"
    style="display: block">
    <app-error></app-error>
    <div class="modal-dialog medium">
        <div class="modal-tnc-content">
            <div class="modal-header">
                <div class="modal-close" (keydown)="keyshiftTabFocus($event, '#tnc-connect');"
                    (keydown.enter)="closeEmailOverlay()" (click)="closeEmailOverlay()" tabindex="0"
                    id="update-modal-close" [attr.aria-label]="('close' | translate)">
                    <svg class="close-icon" role="presentation">
                        <use xlink:href="#in--close" href="#in--close"></use>
                    </svg>
                </div>
                <h4 [innerHtml]="((isUnconfirmedTicket) ? ('emailOverlay.staffHeading' | translate): ('emailOverlay.commercialHeading'  | translate))"
                    class="modal-title" id="tnc-header"></h4>
                <p
                    [innerHtml]="((isUnconfirmedTicket) ? 
                ('emailOverlay.staffInstruction'  | translate): ((isEmailPresent) ? 
                ('emailOverlay.commercialInstruction_email'  | translate): ('emailOverlay.commercialInstruction' | translate)))">
                </p>
            </div>
            <form class="" role="form" name="buy-wifi-updateEmail" [formGroup]="emailForm"
                (ngSubmit)="emailFormSubmit()" novalidate="" form-autofill-fix="" autocomplete="off">
                <div class="req-info-email-only login large-6 medium-6 small-12">
                    <p>{{'reqInfo' | translate}}</p>
                </div>
                <div class="input-set large-6 medium-6 small-12 col activate-input email-input">
                    <label id="emailLabel" [ngClass]="{'top-set': emailTopSet}" for="email">{{'email' |
                        translate}}*</label>
                    <input formControlName='email' tabindex="0"
                        (keydown.tab)="(!emailForm.valid)?'#update-modal-close':'#update-email-connect'"
                        id="update-email-input" name="" type="text" [(ngModel)]="buyWifiService.receiptEmailAddress"
                        (focus)="onActiveEmail()" aria-label="Email" (blur)="onBlurEmail()"
                        (keydown.Tab)="tabFromEmailInput($event)" required aria-required="true" aria-invalid="false" />
                    <div class="tool-tip bottom-left small error onboard-tool-tip"
                        *ngIf="email.invalid && showEmailErrorMsg" role="alert">
                        <div class="tool-tip-inner">
                            <div *ngIf="email.errors.required">{{'message.7011059' | translate}}</div>
                            <div *ngIf="email.errors.pattern">{{'message.7011060' | translate}}</div>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
                <div class="modal-tnc-body">
                    <div class="tnc-content-wrapper">
                        <div class="wrap-button tnc-connect-container">
                            <button class="btn primary large small-12 email-update" id="email.update" tabindex="0"
                                (keydown.Tab)="keytabFocus($event, '#update-modal-close');">{{'tnc.continue' |
                                translate}}</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<div class="clear"></div>
<div id="paymentConfirmationScreen" class="paymentConfirmationScreen" *ngIf="showPaymentConfirmationScreen">
    <app-paymentConfirmation></app-paymentConfirmation>
</div>
<span class="sr-only" id="sr-cart-updateemail" tabindex="-1"></span>